export const verificarEtapaAnterior = (etapas, ordenActual) => {
  // Manejo de casos nulos/undefined
  if (!etapas || !Array.isArray(etapas)) {
    return {
      isQuorumCumplido: false,
      isEtapaActualCerrada: false,
      isEtapaActualPendiente: false,
      isEtapaActualProgramada: false,
      isEtapaAnteriorCumplida: false,
      isEtapaSiguienteCumplida: false,
      estadoActual: null,
      estadoQuorum: null,
      estadoAnterior: null,
      estadoSiguiente: null,
    };
  }

  const etapaQuorum = etapas.find((e) => e.orden === 1);
  const etapaActual = etapas.find((e) => e.orden === ordenActual);
  const etapaAnterior = etapas.find((e) => e.orden === ordenActual - 1);
  const etapaSiguiente = etapas.find((e) => e.orden === ordenActual + 1);

  return {
    isQuorumCumplido: etapaQuorum?.estado === "CUMPLIDA",
    isEtapaActualCerrada: etapaActual?.estado === "CERRADA",
    isEtapaActualPendiente: etapaActual?.estado === "PENDIENTE",
    isEtapaActualProgramada: etapaActual?.estado === "PROGRAMADA",
    isEtapaAnteriorCumplida: ordenActual === 1 ? true : etapaAnterior?.estado === "CUMPLIDA",
    isEtapaSiguienteCumplida: ordenActual === 6 ? true : etapaSiguiente?.estado === "CUMPLIDA",
    estadoQuorum: etapaQuorum?.estado,
    estadoActual: etapaActual?.estado,
    estadoAnterior: etapaAnterior?.estado,
    estadoSiguiente: etapaSiguiente?.estado,
  };
};
